import { FormGroup } from "@angular/forms"

export type FormState = 'initial' | 'normal'

interface State {
  invalid: boolean | undefined
  fields: number
}

export function updateFormState(
  formGroup: FormGroup,
  controlNames: string[],
  isSavedBefore = false
) {
  let state: boolean | undefined = undefined

  const names = controlNames.length 
    ? controlNames
    : Object.keys(formGroup.controls)

  for (const name of names) {
    const control = formGroup.controls[name]
    if (control?.invalid) {
      state = undefined
    } else {
      state = false
    }
  }

  if (isSavedBefore) {
    return state
  } else if (state === false) {
    return false
  }
  return undefined
}